// Component
const CartTable = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "cart-table" */ "@/app/views/main-view/products/components/cart-table/cart-table.vue"
    );
const StoreCreditPreview = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "store-credit-preview" */ "@/app/views/main-view/products/components/store-credit-preview/store-credit-preview.vue"
    );

// Mixins
import { userMixins } from "@/app/mixins/modules/user-mixins";
import { shoppingMixins } from "@/app/mixins/components/shopping-mixins";
import { switchPetMixins } from "@/app/mixins/modules/switch-pet-mixins";

// Services
import storeCreditService from "@/app/services/main/store-credit/store-credit-service.js";

export default {
    name: "ProductCartContainer",
    mixins: [userMixins, shoppingMixins, switchPetMixins],
    components: {
        CartTable,
        StoreCreditPreview,
    },
    data() {
        return {
            isAPILoading: true,
            isStoreCreditAPILoading: true,
            totalPrice: null,
            storeCredit: 0,

            // delivery fee
			deliveryMin: process.env.VUE_APP_DELIVERY_MIN,
			deliveryFee: process.env.VUE_APP_DELIVERY_FEE,

            previousRoute: null,
            currentPage: null,
        };
    },
    computed: {
        disableCheckoutButton() {
            return this.totalPrice === 0 || this.isItemChanged || this.isItemDeactivated || this.isItemOutOfStock;
        },
        isItemChanged() {
            return this.$store.getters.getIsProductChanged;
        },
        isItemDeactivated() {
            return this.$store.getters.getIsProductDeactivated;
        },
        isItemOutOfStock() {
            return this.$store.getters.getIsProductOutOfStock
        },
        selectedCartCount() {
            const { getSelectedCartContent } = this.$store.getters;
            return getSelectedCartContent.length;
        },
    },
    mounted() {
        window.scrollTo(0, 0);
        this.setBackLabel();
    },
    watch: {
        totalPrice(newVal) {
            this.isAPILoading = false;
        },
    },
    created() {
        this.setPendingOrderCount(this.getActivePet.id);
        this.getStoreCredit();
    },
    methods: {
        setBackLabel() {
            if (this.$route.query && this.$route.query.from) {
                const from = this.$route.query.from
                if (from === 'products') {
                    this.previousRoute = 'Product Categories List'
                } else if (from.includes('list')) {
                    this.previousRoute = 'Product List'
                } else if (from.includes('details')) {
                    this.previousRoute = 'Product Details'
                } else if (from.includes('checkout')) {
                    this.previousRoute = 'Checkout'
                }
            }
        },
        refreshActivePetData() {
            this.$refs.cartTable.getCartList();
            this.$store.commit("clearSelectedCartTableAndContent");
            this.$store.commit("resetIsProductDeactivated");
            this.$store.commit("resetIsProductChanged");

            this.setPendingOrderCount(this.getActivePet.id);
        },
        goToCheckout() {
            if (!this.disableCheckoutButton) {
                this.$router.push("/products/checkout?from=cart");
            }
        },
        getStoreCredit() {
            this.isStoreCreditAPILoading = true;

            storeCreditService
                .getStoreCredit()
                .then((res) => {
                    if (res.status === 200) {
                        this.storeCredit = res.data.data.amount;
                    }
                })
                .catch(() => {
                    this.showGenericErrorToast();
                }).finally(() => {
                    this.isStoreCreditAPILoading = false;
                })
        },
        redirectToShop(){
            const returnFromPayment = this.$route.query.returnFromPayment;

            if(returnFromPayment){
                this.$router.push("/products");
            } else {
                this.$router.go(-1);
            }
            
        },
    },
};
